import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { blobPath } from "@circle-react/helpers/urlHelpers";

export const CoverImage = () => {
  const { paywall } = usePaywallCheckoutContext();

  const imageUrl =
    paywall.paywall_customization.cover_image_url ||
    blobPath({
      filename: "cover_image",
      signed_id: paywall.paywall_customization.cover_image,
    });

  return (
    <img
      loading="lazy"
      alt=""
      src={imageUrl}
      className="relative max-h-[303px] w-full rounded-t-xl object-cover"
      data-testid="paywall-cover-image"
    />
  );
};
